// Datos de artículos del blog. Para añadir un nuevo post, simplemente agrega un objeto a este array.
// El campo `slug` se usa en la URL: /blog/:slug
// El campo `content` admite HTML simple (se renderiza con dangerouslySetInnerHTML).
// Las imágenes pueden ser URLs externas o rutas locales (/images/blog-N.webp).

export const blogPosts = [
  {
    slug: "kak-vybrat-chastnuyu-shkolu-ramenskoe",
    title: "Как выбрать частную школу в Раменском",
    description:
      "Практические советы родителям: на что обратить внимание при выборе частной школы в Раменском районе — от лицензии до программы и атмосферы.",
    image:
      "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=1200&q=80",
    date: "2026-04-20",
    readingTime: "6 мин",
    content: `
      <p>Выбор школы — одно из самых ответственных решений в жизни семьи. От него зависит не только академическая успеваемость ребёнка, но и его эмоциональное состояние, мотивация и интерес к учёбе.</p>
      <h2>1. Лицензия и аккредитация</h2>
      <p>В первую очередь убедитесь, что у школы есть действующая лицензия на образовательную деятельность и государственная аккредитация. Это гарантирует, что выпускники получат документ установленного образца.</p>
      <h2>2. Размер класса</h2>
      <p>Небольшие классы (до 12 человек) позволяют учителю уделять внимание каждому ребёнку. В частной школе «Древо Познаний» именно такая модель — индивидуальный подход в каждом классе.</p>
      <h2>3. Программа и подготовка к экзаменам</h2>
      <p>Узнайте, по каким программам ведётся обучение и как организована подготовка к ОГЭ и ЕГЭ. Хорошая школа предлагает гарантированный результат и работу с пробелами в знаниях.</p>
      <h2>4. Атмосфера и педагоги</h2>
      <p>Посетите школу лично, поговорите с учителями и учениками, обратите внимание на интерьеры и настроение детей. Тёплая атмосфера и опытный коллектив — это половина успеха.</p>
      <h2>5. Дополнительные занятия и развитие</h2>
      <p>Хорошая школа предлагает кружки, спортивные секции, экскурсии и творческие мастерские. Это развивает у ребёнка широкий кругозор и навыки общения.</p>
      <p><strong>Хотите увидеть всё своими глазами?</strong> Запишитесь на пробный день в «Древо Познаний» и убедитесь сами.</p>
    `,
  },
  {
    slug: "podgotovka-k-ege-2026",
    title: "Подготовка к ЕГЭ 2026: что важно знать родителям",
    description:
      "Разбираем ключевые изменения ЕГЭ 2026 года и рассказываем, как организовать подготовку без стресса и с гарантированным результатом.",
    image:
      "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?auto=format&fit=crop&w=1200&q=80",
    date: "2026-04-15",
    readingTime: "8 мин",
    content: `
      <p>ЕГЭ — это не только экзамен, но и важный этап взросления школьника. От качества подготовки зависит, в какой вуз поступит ребёнок и насколько уверенно он будет чувствовать себя в новой среде.</p>
      <h2>Когда начинать подготовку</h2>
      <p>Оптимально — за 1,5–2 года до экзамена. За это время можно спокойно проработать весь материал, разобрать сложные темы и научиться эффективно решать тестовые задания.</p>
      <h2>Как организовать процесс</h2>
      <ul>
        <li>Составьте чёткий график занятий по предметам</li>
        <li>Регулярно проводите пробные тестирования</li>
        <li>Анализируйте ошибки и работайте над пробелами</li>
        <li>Не забывайте об отдыхе и спорте</li>
      </ul>
      <h2>Роль школы</h2>
      <p>В «Древо Познаний» подготовка к ЕГЭ интегрирована в учебный процесс с 10 класса. Опытные педагоги помогают каждому ученику достичь высоких баллов — наш средний балл ЕГЭ составляет 87, а 97% выпускников поступают в государственные вузы.</p>
      <h2>Совет родителям</h2>
      <p>Главное — поддержка и уверенность. Не нагнетайте обстановку, дайте ребёнку понять, что вы рядом, а команда школы поможет с академической частью.</p>
    `,
  },
  {
    slug: "vneurochnaya-deyatelnost-v-shkole",
    title: "Внеурочная деятельность: зачем она нужна школьнику",
    description:
      "Кружки, секции, экскурсии и творческие мастерские — почему внеурочная активность так же важна, как и сама учёба.",
    image:
      "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=1200&q=80",
    date: "2026-04-10",
    readingTime: "5 мин",
    content: `
      <p>Современное образование — это не только уроки и домашние задания. Внеурочная деятельность играет ключевую роль в формировании личности и развитии ребёнка.</p>
      <h2>Что даёт внеурочная активность</h2>
      <ul>
        <li><strong>Развитие талантов</strong> — ребёнок пробует себя в разных направлениях и находит то, что ему действительно интересно</li>
        <li><strong>Социальные навыки</strong> — общение в группе по интересам формирует уверенность и умение работать в команде</li>
        <li><strong>Снижение стресса</strong> — смена деятельности помогает мозгу отдохнуть от учебной нагрузки</li>
        <li><strong>Расширение кругозора</strong> — экскурсии, конкурсы, проекты дают опыт за пределами учебника</li>
      </ul>
      <h2>Внеурочные программы в «Древо Познаний»</h2>
      <p>В нашей школе действуют кружки английского, шахмат, робототехники, театральная студия, спортивные секции и творческие мастерские. Каждый ребёнок найдёт занятие по душе.</p>
      <p>Мы регулярно организуем экскурсии в музеи Москвы, выезды на природу и тематические недели. Это делает школьную жизнь насыщенной и запоминающейся.</p>
    `,
  },
];

// Helper para encontrar artículо por slug
export const getPostBySlug = (slug) =>
  blogPosts.find((post) => post.slug === slug);

// Helper para obtener artículos ordenados por fecha (más nuevos primero)
export const getSortedPosts = () =>
  [...blogPosts].sort((a, b) => new Date(b.date) - new Date(a.date));
